import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { NotificationService } from '@core/services';
import { SharedComponentsSysTextService } from '@core/services/shared-components-sys-text.service';

// Names a standalone loading spinner "loading" for screen readers (an unnamed mat-spinner is a progress bar with no
// name) and announces it when it appears (the waiting state is a status message, and a progress bar isn't a live
// region). The text comes from the shared sysText, which loads at app start, so it's there while a page's own text
// loads. Left alone: a button's progress indicator (Material's showProgress; not matched, the button carries the
// name), spinners inside a button, link or mat-icon (the control names them; mat-icon hides its content), and
// spinners that already have a label
@Directive({
  selector: 'mat-spinner:not([progressIndicator])',
  standalone: false
})
export class LoadingSpinnerLabelDirective implements AfterViewInit {
  constructor(
    private el: ElementRef<HTMLElement>,
    private text: SharedComponentsSysTextService,
    private notificationService: NotificationService
  ) {}

  // after the view is in place, so closest() sees the spinner's real parents (a spinner in an @if block isn't under
  // its button yet when it's created)
  ngAfterViewInit(): void {
    const spinner = this.el.nativeElement;

    if (spinner.hasAttribute('aria-label') || spinner.closest('button, a, [role="button"], mat-icon')) {
      return;
    }

    const label = this.text.sysText?.[this.text.templates.loadingSpinner]?.loading_ariaLabel;

    if (label) {
      spinner.setAttribute('aria-label', label);
      this.notificationService.announceStatus(label);
    }
  }
}
